import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M43 40a3 3 0 01-6 0V16.48a.5.5 0 00-.595-.494.52.52 0 00-.265.134l-26 26a3.006 3.006 0 01-4.26-4.24l26-26a.48.48 0 000-.54.5.5 0 00-.46-.3H8a3 3 0 010-6h30a5 5 0 013.56 1.48A5.06 5.06 0 0143 10v30z",
      fill: "#000"
    }
  )
);
export {
  t as default
};
